import { Box, styled } from "@mui/material";

export const StyledDashboardBarChart = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
}));
